import React, { useRef, useState, useEffect } from 'react';
import JsPsychTask from '../../components/jspsych/JsPsychTask';
import fullscreen from "@jspsych/plugin-fullscreen";
import jsPsychHtmlButtonResponse from '@jspsych/plugin-html-button-response';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import JsPsychTaskPratice from '../../components/jspsych/JsPsychTaskPratice';
import JsPsychTaskMain from '../../components/jspsych/JsPsychTaskMain';
import apiAuth from '../../services/authServiceLogin';
import CoursesManagementList from '../../services/coursesManagementSerives';
import errorHandler from '../../utils/errorHandler';
import { AUDIO_BASE } from '../../utils/constants';
import allTaskDescriptions from '../../utils/AllTaskDescription.json';

const TaskComponent = () => {
  const jsPsychRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id, taskId } = useParams();
  const [showFullScreenButton, setShowFullScreenButton] = useState(true);
  const [taskStarted, setTaskStarted] = useState(false);
  const [timelineVariables, setTimelineVariables] = useState([]);
  const [timeout, setTimeout] = useState(15000);
  const { panelType } = location.state || {};
  const [task, getTask] = useState([]);
  const [type, getType] = useState('');
  const [data, getData] = useState('');
  const [primaryText, setPrimaryText] = useState('');
  const [secondaryText, setSecondaryText] = useState('');
  const [timeL, setTimeL] = useState([]);
  const { languageName } = location.state || {};

  useEffect(() => {
    return () => {
      if ('caches' in window) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      }

      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((registration) => {
            registration.unregister();
          });
        });
      }

      window.location.reload(true);
    };
  }, [location, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const payload = {
          taskId: taskId,
          courseId: id,
        }
        const response = await CoursesManagementList.AllTaskget(payload);

        const item = response.data.data;
        const url = AUDIO_BASE + item?.audio;
        const result = { ...item, audio: url };
        getData(response?.data)
        const urls = await Promise.all(
          response?.data?.data?.map(
            async (item) => {
              const url = AUDIO_BASE + item?.audio;
              return { ...item, audio: url };
            }
          )
        );
        getTask(urls);
        getType(response.data.type);

        if (response?.data?.type == 'main') {
          setSecondaryText(response?.data?.main_secondary)
        } else if (response.data.type === 'practice') {
          setSecondaryText(response?.data?.practice_secondary)
        } else {
          setSecondaryText(response?.data?.baseline_secondary)
          setPrimaryText(response?.data?.baseline_primary)
        }
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id, taskId]);


  useEffect(() => {

    if (primaryText || secondaryText) {
      setTimeL([
        {
          type: jsPsychHtmlButtonResponse,
          stimulus: ` <div class="start-task-des"><figure><img src="/images/i-help.svg" alt="Help" /></figure>
                  ${primaryText ? primaryText : secondaryText}</div>`,
          choices: ['Start'],
          button_html: (choice) => `<div class="start-task-des"><div class="start-btn">
                  <button type="button" class="btn">${choice}</button>
                </div></div>`
        }
      ])
    }
  }, [secondaryText, primaryText]);

  useEffect(() => {
    if (task?.length) {
      const fetchedTimelineVariables = task?.map(item => ({
        answer: item.answer,
        audio: item.audio,
        choices: item.options,
        id: item.questionId,
        courseId: id,
        taskId: taskId,
        trailPart: item?.trailPart,
      }));

      const validTimelineVariables = fetchedTimelineVariables.filter(item => {
        return item.audio && item.audio.startsWith('http');
      });

      const shuffledTimelineVariables = validTimelineVariables
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);

      setTimelineVariables(shuffledTimelineVariables);
    }
  }, [task, type]);

  useEffect(() => {
    const TimeOutGet = async () => {
      try {
        let data = await apiAuth.getSetting();
        if (data?.status === 200) {
          const time = data?.data?.data?.timer * 1000
          setTimeout(time)
        }
      } catch (err) { }
    };
    TimeOutGet();
  }, []);


  const handleComplete = (data) => {
    navigate(`task`)
  };


  useEffect(() => {
    if (jsPsychRef.current && timelineVariables?.length) {
      jsPsychRef.current.innerHTML = '';
     
      if (type === "practice") {
        JsPsychTaskPratice({
          onComplete: handleComplete,
          display_element: jsPsychRef?.current,
          timeL: timeL,
          timelineVariables: timelineVariables,
          setTaskStarted: setTaskStarted,
          timeout: timeout,
          panelType
        });
      }
      else if (type === "main") {
        JsPsychTaskMain({
          onComplete: handleComplete,
          display_element: jsPsychRef?.current,
          timeL: timeL,
          timelineVariables: timelineVariables,
          setTaskStarted: setTaskStarted,
          timeout: timeout,
          panelType
        });
      }
      else {
        JsPsychTask({
          onComplete: handleComplete,
          display_element: jsPsychRef?.current,
          timeL: timeL,
          timelineVariables: timelineVariables,
          setTaskStarted: setTaskStarted,
          timeout: timeout,
          panelType,
          instructionText: secondaryText,
        });
      }
    }
  }, [timeL, timelineVariables, type, secondaryText]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document?.fullscreenElement) {
        // setShowFullScreenButton(true);
      }
    };

    document?.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document?.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const check = () => {
      if (document?.fullscreenElement) {
        document?.exitFullscreen();
      }
    };
    return () => check();
  }, []);

  return (
    <div class="white-bg padd30 student-courses-content-bg">
      <div class="start-task-box">
        <div class="start-task-des">
          <div ref={jsPsychRef} style={{ width: '100%', height: '100%' }}></div>
        </div>
      </div>
    </div>
  );
};

export default TaskComponent;